import {
  Alert,
  Button, Card, Form, Input, message, Typography,
} from 'antd';
import { fetchMyOrganizations } from 'api/organizations';
import Layout from 'components/Layout';
import { AdminContext } from 'constants/contexts';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import http, { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';
import { WL_CONFIG } from 'constants';
import { getData } from '../../utils';

const Logo = WL_CONFIG.logo.medium;

function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showMigrationMessage, setMigrationMessage] = useState('');
  const {
    isLoggedIn, organization, setOrganization, setUser,
  } = useContext(AdminContext);
  const handleSubmit = (data) => {
    setLoading(true);
    http.post('user/login/super-user/', data, {
      headers: {
        Authorization: '',
      },
    })
      .then((res) => {
        const authToken = getData(res)?.key;
        if (authToken) {
          setUser({ ...res.data, authToken });
          http.get('user/rest-auth/user/', {
            headers: {
              Authorization: `Token ${authToken}`,
            },
          }).then((res) => {
            fetchMyOrganizations().then((data) => {
              if (!organization && data.results?.length) {
                setOrganization(data.results[0]);
              }
              navigate({
                pathname: '/console',
                state: { from: 'login' },
              });
              setLoading(false);
              setUser(res.data);
            }).catch((e) => {
              captureException(e);
              console.log(e.response);
              message.error(getHttpErrorMessage(e));
              setLoading(false);
            });
          }).catch((e) => {
            console.log(e.response);
            captureException(e);
            message.error(getHttpErrorMessage(e));
            setLoading(false);
          });
        }
      })
      .catch((e) => {
        if (e.response.data.errors?.[0]?.non_field_errors === 'Unable to log in with provided credentials.') {
          setMigrationMessage(true);
        }

        captureException(e);
        setLoading(false);
        message.error(getHttpErrorMessage(e));
      });
  };

  if (isLoggedIn) {
    navigate({
      pathname: '/console',
      state: { from: 'login' },
    });
  }

  return (
    <Layout hasSidebar={false}>
      <div className="w-screen h-screen flex items-center justify-center">
        <Card className="w-96">
          <div className="flex items-center justify-center mb-5">
            <Logo style={{ width: '100%' }} />
          </div>
          <Typography.Title level={1} className="mt-3" style={{ fontSize: 24 }}>
            Sign in to your account
          </Typography.Title>
          {
            showMigrationMessage && (
              <Alert
                message={(
                  <>
                    If you are a CRM user, we have migrated to a new platform. Please sign in at our new location:
                    {' '}
                    <a href="https://admin.omnirev.ai" rel="noopener">https://admin.omnirev.ai</a>
                  </>
                )}
                type="warning"
                className="mb-6"
              />
            )
          }
          <Form
            onFinish={handleSubmit}
            className="mt-6"
            validateTrigger="onSubmit"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password placeholder="password" />
            </Form.Item>
            <Link to="/forget-password">Forgot your password?</Link>
            <Form.Item>
              <Button
                block
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                className="mt-5"
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Layout>
  );
}

export default Login;
